var map = {
	"./amanda-lee.jpg": 45099,
	"./emily-davis.jpg": 55738,
	"./extension-demo.jpg": 80037,
	"./john-martinez.jpg": 43770,
	"./kevin-johnson.jpg": 67719,
	"./michael-robinson.jpg": 28760,
	"./olivia-garcia.jpg": 93986,
	"./sarah-thompson.jpg": 72422,
	"./tnp-in progress.jpg": 95861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29913;